import { getApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'

import { getFirebase, globalApi } from 'modules/App/globalApi'
import { CONTENT_STATS_FUNCTION } from './contentStatsUtils'

export const contentStatsApi = globalApi.injectEndpoints({
  endpoints: (build) => ({
    // "on" when this coach's Content Stats is switched on (orgAnalytics/{coachOrgId}/contentStatsAccess,
    // set by the monthly job or by hand). Anything else, including a failed read, means hidden.
    getContentStatsAccess: build.query({
      queryFn: async ({ coachOrgId }) => {
        const { data } = await getFirebase(`orgAnalytics/${coachOrgId}/contentStatsAccess/status`)
        return { data: data || null }
      },
    }),
    // The callable checks that the caller is an admin of the org or a Trybe admin, and saves each
    // month it fetches from Amplitude, so asking again for the same month is cheap.
    getContentStats: build.mutation({
      queryFn: async ({ coachOrgId, month }) => {
        try {
          const getStats = httpsCallable(getFunctions(getApp()), CONTENT_STATS_FUNCTION)
          const { data } = await getStats({ coachOrgId, month })
          return { data }
        } catch (err) {
          return { error: { code: err?.code, message: err?.message } }
        }
      },
    }),
  }),
})

export const { useGetContentStatsMutation, useGetContentStatsAccessQuery } = contentStatsApi

// A month the cloud function already saved, read straight from the database, or null when there is
// none or it can't be read
export async function getSavedMonth(coachOrgId, month) {
  const { data, error } = await getFirebase(`orgAnalytics/${coachOrgId}/contentStats/${month}`)
  return error ? null : data || null
}
